import {
  MessagesSquare,
  GraduationCap,
  PenLine,
  UserRound,
  Leaf,
  Landmark,
  HeartPulse,
  Cpu,
  Briefcase,
  Megaphone,
  Instagram,
  Youtube,
  Send,
  Twitter,
} from "lucide-react";

export const BRAND = {
  en: "English Mastery Lab",
  tagline: "مدرب IELTS ومحادثة إنجليزية",
};

export const HERO = {
  badge: "مدرب IELTS • محادثة • قواعد",
  titleA: "تعلّم الإنجليزية بثقة،",
  titleB: "وتحدّث بطلاقة حقيقية",
  sub: "دروس مقالية بمستويات B1 وB2 وC1، دليل قواعد شامل من A1 إلى C1، وجلسات فردية مصممة لهدفك — خطوة بخطوة نحو درجة أعلى في IELTS وثقة أكبر في الحديث.",
  ctaPrimary: "احجز جلستك الآن",
  ctaSecondary: "استكشف الدروس",
};

export const BIO = {
  eyebrow: "نبذة عني",
  title: "مرحباً! أنا مدربك للغة الإنجليزية",
  paragraphs: [
    "مدرب لغة إنجليزية متخصص في تحضير الطلاب لاختبار IELTS وتطوير طلاقة المحادثة. أعمل مع الشباب الجامعيين والمهنيين الشباب على بناء ثقة حقيقية في استخدام اللغة، لا مجرد حفظ القواعد.",
    "منهجي يقوم على الاستخدام الحقيقي للغة: نصوص من واقع الحياة والاختبارات، مفردات تُستخدم فوراً، ومحادثات موجهة تحاكي مواقف الاختبار والمقابلات العملية. كل درس يبني على الذي قبله، وكل جلسة تخرج منها بمستوى أوضح وأعلى.",
  ],
  specialties: ["محادثة طلاقة وثقة", "تحضير مكثف لـ IELTS", "قواعد من A1 إلى C1", "خطة فردية حسب هدفك"],
  placeholderNote: "السيرة والصورة مؤقتة — استبدلها بمحتواك الحقيقي من الملف src/data/site.js",
};

export const SERVICES = [
  {
    icon: MessagesSquare,
    title: "تدريب المحادثة",
    desc: "جلسات محادثة عملية تبني طلاقتك وثقتك في مواقف الحياة والدراسة والعمل الحقيقية.",
  },
  {
    icon: GraduationCap,
    title: "تحضير IELTS",
    desc: "استراتيجيات مجرّبة لكل أقسام الاختبار، محاكاة كاملة للسبيكنغ، وتقييم مفصل لمستواك.",
  },
  {
    icon: PenLine,
    title: "القواعد ببساطة",
    desc: "شرح متدرج لقواعد اللغة من A1 إلى C1 بأمثلة واقعية وترجمات عربية وتدريبات مباشرة.",
  },
  {
    icon: UserRound,
    title: "جلسات فردية",
    desc: "خطة مخصصة لهدفك بالضبط: اختبار دولي، مقابلة عمل، سفر، أو تطوير مهني مستمر.",
  },
];

export const LEVELS = {
  B1: { key: "B1", name: "متوسط", color: "#2DD4BF" },
  B2: { key: "B2", name: "فوق المتوسط", color: "#60A5FA" },
  C1: { key: "C1", name: "متقدم", color: "#E2B75C" },
};

export const LEVEL_ORDER = ["B1", "B2", "C1"];

export const DOMAINS = {
  education: { ar: "التعليم", icon: GraduationCap },
  environment: { ar: "البيئة", icon: Leaf },
  government: { ar: "الحكومة والمجتمع", icon: Landmark },
  health: { ar: "الصحة", icon: HeartPulse },
  technology: { ar: "التكنولوجيا", icon: Cpu },
  work: { ar: "عالم العمل", icon: Briefcase },
  media: { ar: "الإعلام والمجتمع", icon: Megaphone },
};

export const TESTIMONIALS_NOTE = "نماذج مؤقتة — تُستبدل بآراء طلابك الحقيقية";

export const TESTIMONIALS = [
  {
    name: "سارة م.",
    tag: "طالبة IELTS",
    quote:
      "كنت أتجمد عند قسم المحادثة، وبعد أشهر من الجلسات صرت أتكلم بثقة وبنية واضحة. أسلوب التدريب عملي ويركز على نقاط ضعفي بالضبط.",
  },
  {
    name: "أحمد ك.",
    tag: "مهندس برمجيات",
    quote:
      "أول مرة أستخدم الإنجليزية في اجتماعات العمل بدون ترجمة ذهنية. الدروس المقالية والمفردات اليومية صنعت فرقاً حقيقياً عندي.",
  },
  {
    name: "ليان ع.",
    tag: "جامعية",
    quote:
      "شرح القواعد عنده مختلف تماماً — بسيط، مرتب، وكل قاعدة معها مثال وترجمة. أخيراً صارت القواعد شي أفهمه مو شي أحفظه.",
  },
  {
    name: "عمر ح.",
    tag: "طالب دراسات عليا",
    quote:
      "خطة المراجعة الفردية قبل الاختبار كانت مركزة جداً، والتغذية الراجعة بعد كل جلسة محاكاة ساعدتني أرفع درجتي بسرعة.",
  },
];

export const CONTACT = {
  title: "جاهز تبدأ رحلتك؟",
  desc: "احجز جلسة تعريفية أو أرسل استفسارك وسأعود إليك بأقرب وقت. الخدمة تستقبل رسالتك وسيتم ربطها بقناة الاستلام التي تفضلها لاحقاً.",
  email: "hello@example.com",
  whatsapp: "+000 000 0000",
};

export const SOCIALS = [
  { name: "Instagram", icon: Instagram, href: "#" },
  { name: "YouTube", icon: Youtube, href: "#" },
  { name: "Telegram", icon: Send, href: "#" },
  { name: "X", icon: Twitter, href: "#" },
];

export const NAV_LINKS = [
  { label: "الرئيسية", href: "/" },
  { label: "نبذة عني", href: "/#about" },
  { label: "الخدمات", href: "/#services" },
  { label: "مكتبة الدروس", href: "/#library" },
  { label: "دليل القواعد", href: "/grammar" },
  { label: "آراء الطلاب", href: "/#testimonials" },
];
